<template>
    <v-app id="splash">
        <v-container fluid>
             <v-layout justify-center row class="mt-lg-0 mt-10">

                 <v-flex lg12 xs8 class="mt-lg-16 pt-lg-16 mt-16 ml-lg-0">
                     
                    <v-img src="../assets/images/LevelTest/reports/mega_blue.png" aspect-ratio="1" class="logo-size " contain></v-img>
                
                 </v-flex>
             </v-layout>
                    <v-layout row class="text-center mt-10"> 
                        <v-flex lg4 xs12>
                            <div> <span class="font-weight-medium"> Forms </span> </div>
                            <!-- <a href="/leveltest"> -->
                                <v-btn class=" mt-lg-2 mt-3"  dark color="primary" @click="levelform()">
                                    <v-icon dark>
                                        mdi-format-list-bulleted-square
                                    </v-icon>
                                    <span class="ml-2"> Level Test Form </span>
                                </v-btn>
                                 <v-btn class=" mt-lg-2 mt-3"  dark color="pink" @click="rcform()">
                                    <v-icon dark>
                                        mdi-format-list-bulleted-square
                                    </v-icon>
                                    <span class="ml-2"> Regular Class Form </span>
                                </v-btn>
                                <v-btn class=" mt-lg-2 mt-3"  dark color="success" @click="fbform()">
                                    <v-icon dark>
                                        mdi-format-list-bulleted-square
                                    </v-icon>
                                    <span class="ml-2"> FeedBack Form </span>
                                </v-btn>
                            <!-- </a> -->
                        </v-flex>
                        <v-flex lg4 xs12 class=" mt-lg-0 mt-5">
                            <div> <span class="font-weight-medium  "> Reports </span> </div>
                            <!-- <a href="/leveltest"> -->
                                 <v-btn class="mx-2 mt-lg-2 mt-3"  dark color="success" @click="ltreport()">
                                    <v-icon dark>
                                        mdi-clipboard-check
                                    </v-icon>
                                    <span class="ml-2"> Level Test Report </span>
                                </v-btn>
                                <v-btn class="mx-2 mt-lg-2 mt-3"  dark color="primary" @click="rcreport()">
                                    <v-icon dark>
                                        mdi-clipboard-check
                                    </v-icon>
                                    <span class="ml-2"> Regular Class Report </span>
                                </v-btn>
                                <v-btn class="mx-2 mt-lg-2 mt-3"  dark color="pink" @click="smreport()">
                                    <v-icon dark>
                                        mdi-clipboard-check
                                    </v-icon>
                                    <span class="ml-2"> Student Rating <br> Monitoring </span>
                                </v-btn> <br>
                                <v-btn class="mx-2 mt-lg-2 mt-3"  dark color="green" @click="tmpreport()">
                                    <v-icon dark>
                                        mdi-clipboard-check
                                    </v-icon>
                                    <span class="ml-2"> Tutor Monthly <br> Performance </span>
                                </v-btn>
                                
                            <!-- </a> -->
                        </v-flex>
                         <v-flex lg4 xs12 class=" mt-lg-0 mt-5 pb-lg-0 pb-6">
                            <div> <span class="font-weight-medium"> Materials </span> </div>
                            <!-- <a href="/leveltest"> -->
                               <v-btn class="mx-2 mt-lg-2 mt-3"  dark color="red" @click="ltmaterial()">
                                    <v-icon dark>
                                        mdi-book-open
                                    </v-icon>
                                    <span class="ml-2"> Level Test Material </span>
                                </v-btn>
                                
                            <!-- </a> -->
                        </v-flex>
                        
                             
                    </v-layout>
                
                     


        </v-container>
    </v-app>
</template>
<style scoped>
#splash{
    background: radial-gradient(472.77% 67.8% at 50% 15.55%, #FFFFFF 20.83%, #8BDCFF 100%);
    background-size: 100% 100%;
}
.logo-size{
    height:150px;
}
@media only screen and (max-width: 1200px) {
  .logo-size{
    height:100px;
    width:250px;
}
}
</style>
<script>
import Vue from 'vue'
export default {
    mounted(){
            if(this.$router.history.current.fullPath != '/rcevaluation/'+this.$route.params.s_id+'/'+this.$route.params.todate || this.$router.history.current.fullPath != '/rcform/'+this.$route.params.s_id+'/'+this.$route.params.todate || this.$router.history.current.fullPath != '/rcform/'+this.$route.params.s_id+'/'+this.$route.params.todate+'/'+this.$route.params.actionrc  ){
                Vue.prototype.$audiopro.pause()
             }
    },
   methods:{
        levelform(){
            // window.location.href="/previewMaterial?l_id="+this.$route.query.l_id
            this.$router.push({name:'leveltestform',params:{l_id:this.$route.params.l_id,action:this.$route.params.action}})
        },
        rcform(){
            // window.location.href="/previewMaterial?l_id="+this.$route.query.l_id
            this.$router.push({name:'rcform',params:{s_id:this.$route.params.s_id,todate:this.$route.params.todate,actionrc:this.$route.params.action}})
        },
        fbform(){
            // window.location.href="/previewMaterial?l_id="+this.$route.query.l_id
            this.$router.push({name:'feedbackformStudentNew',params:{l_id:this.$route.params.l_id}})
        },
        ltreport(){
            // window.location.href="/previewMaterial?l_id="+this.$route.query.l_id
            this.$router.push({name:'Evaluation2',params:{l_id:this.$route.params.l_id}})
        },
        rcreport(){
            // window.location.href="/previewMaterial?l_id="+this.$route.query.l_id
            this.$router.push({name:'rcevaluation',params:{s_id:this.$route.params.s_id,todate:this.$route.params.todate}})
        },
        smreport(){
            // window.location.href="/previewMaterial?l_id="+this.$route.query.l_id
            this.$router.push({name:'ratingmonitoring',params:{l_id:this.$route.params.l_id}})
        },
        ltmaterial(){
            this.$router.push({name:'LevelTestSplash',params:{l_id:this.$route.params.l_id}})
        },
       tmpreport(){
            this.$router.push({name:'tutorMP'})
        }
    }
}
</script>